import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { ContextMenu } from '~/components/Atoms/ContextMenu'
import { Toast } from '~/components/Molecules/Toast'
import useDownload from '~/utils/hooks/useDownload'

import pdfIcon from '~/assets/pdfIcon.png'
import pptIcon from '~/assets/pptIcon.png'

export function DownloadContext({
  open,
  setOpen,
  anchorEl,
  id,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  anchorEl: null | HTMLElement
  id: string
}) {
  const { downloadStat, error, setError } = useDownload()
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <ContextMenu
      open={open}
      onClose={() => {
        setOpen(false)
      }}
      anchorEl={anchorEl}
    >
      <MenuItem
        onClick={() => {
          downloadStat(id, 'pdf')
        }}
        sx={{ width: '300px', padding: 0 }}
      >
        <Box display="flex" justifyContent="space-between" width="100%" padding={theme.spacing.L}>
          <Box display="flex" gap={theme.spacing.M} alignItems="center">
            <img src={pdfIcon} />
            <Typography variant="body">{t('reports:pdf')}</Typography>
          </Box>
          <DownloadOutlinedIcon />
        </Box>
      </MenuItem>
      <MenuItem
        onClick={() => {
          downloadStat(id, 'ppt')
        }}
        sx={{ width: '300px', padding: 0 }}
      >
        <Box display="flex" justifyContent="space-between" width="100%" padding={theme.spacing.L}>
          <Box display="flex" gap={theme.spacing.M} alignItems="center">
            <img src={pptIcon} />
            <Typography variant="body">{t('reports:ppt')}</Typography>
          </Box>
          <DownloadOutlinedIcon />
        </Box>
      </MenuItem>
      <Toast state="error" open={!!error} message={error} onClose={() => setError(null)} />
    </ContextMenu>
  )
}
